import React from 'react';
import { CardContainer } from '../../shared/components/card';
import { TagSelectInput } from '../../shared/components/tagSelect';
import { nullFn } from '../../shared/utils';

type DevTagType = { id: string; label: string };

export class TagsDevelopmentPage extends React.Component {
  render(): JSX.Element {
    const tags: DevTagType[] = [
      {
        id: '1',
        label: 'Covid 19',
      },
      {
        id: '2',
        label: 'Work',
      },
      {
        id: '3',
        label: 'Play',
      },
      {
        id: '4',
        label: 'Sleep',
      },
      {
        id: '5',
        label: 'Community',
      },
      {
        id: '6',
        label: 'Coke',
      },
    ];

    return (
      <div className='bg-gray-lightest w-full min-h-screen'>
        <div className='w-3/4 mx-auto py-20'>
          <h1>Tags Input Development</h1>
          <CardContainer stripPadding={false}>
            <TagSelectInput
              data={tags}
              label='Tags'
              name='tags'
              classes={['mb-10']}
              max={10}
              placeholder='Select a tag'
              onSelectedOptionsChange={nullFn}
            />
          </CardContainer>
        </div>
      </div>
    );
  }
}
